module.exports = __webpack_public_path__ + "img/5.5cbe7f69.webp";